<script>
  const alefba = [
      "ا",
      "ب",
      "پ",
      "ت",
      "ث",
      "ج",
      "چ",
      "ح",
      "خ",
      "د",
      "ذ",
      "ر",
      "ز",
      "ژ",
      "س",
      "ش",
      "ص",
      "ض",
      "ط",
      "ظ",
      "ع",
      "غ",
      "ف",
      "ق",
      "ک",
      "گ",
      "ل",
      "م",
      "ن",
      "و",
      "ه",
      "ی"
    ],
    URL = "http://nepi.ir/public/nepi/items/taarif";
  let alefbaExist = [],
    selectIndex = 0,
    output,
    total = -1,
    promise = getData("ا"),
    header = null;

  const initData = (async function() {
    const _al = await fetch(URL + "?fields=alefba&limit=-1");
    const data = await _al.text();
    if (_al.ok) {
      let _dJ = JSON.parse(data).data;
      alefbaExist = [...new Set(_dJ.map(obj => obj.alefba))];
      total = _dJ.length;
    } else {
      throw new Error(data);
    }
  })();

  async function getData(alefba) {
    const res = await fetch(URL + `?filter[alefba][eq]=` + alefba);
    const data = await res.text();
    if (res.ok) {
      manipulate(JSON.parse(data).data);
      return true;
    } else {
      throw new Error(data);
    }
  }

  function alphabetClick(e, i) {
    header = null;
    document.getElementById("search").value = "";
    selectIndex = i;
    promise = getData(alefba[i]);
    window.scrollTo(0, 0);
  }
  function manipulate(terms) {
    output = [];
    terms.forEach(function(item) {
      var existing = output.filter(function(v, i) {
        return v.title == item.title;
      });
      if (existing.length) {
        var existingIndex = output.indexOf(existing[0]);
        if (output[existingIndex].tarif) output[existingIndex].tarif.push(item);
        else output[existingIndex].tarif = [];
        // output[existingIndex].des = output[existingIndex].des.concat(item.des);
      } else {
        // if (typeof item.des == "string") item.des = [item.des];
        if (typeof item.des == "string") {
          item.tarif = [item];
        }
        output.push(item);
      }
    });
    // console.log(output);
  }

  async function searchRun(e) {
    //جستجو درست جواب نمیده چون یونیکد نمی فرسته متن رو
    if (e.keyCode == 13) {
      let q = e.target.value.trim();
      if (q.length < 1) return false;
      console.log(q);
      const res = await fetch(URL + `?filter[title][rlike]=%${q}%`);
      const data = await res.text();
      if (res.ok) {
        selectIndex = -1;
        let result = JSON.parse(data).data;
        if (result.length > 1) {
          header = "تعداد نتیجه " + result.length;
          manipulate(result);
        } else {
          header = "برای " + q;
          manipulate([]);
        }
        return true;
      } else {
        throw new Error(data);
      }
    }
  }

  async function showAll(e) {
    if(!e.ctrlKey) return false
    const res = await fetch(URL + "?limit=-1");
    const data = await res.text();
    if (res.ok) {
      // let all = JSON.parse(data).data;
      // all.sort(function(a, b) {
      //   var nameA = a.title.toUpperCase(); // ignore upper and lowercase
      //   var nameB = b.title.toUpperCase(); // ignore upper and lowercase
      //   if (nameA < nameB) {
      //     return -1;
      //   }
      //   if (nameA > nameB) {
      //     return 1;
      //   }

      //   // names must be equal
      //   return 0;
      // });
      manipulate(JSON.parse(data).data);
      return true;
    } else {
      throw new Error(data);
    }
  }

  
</script>

<main>
  <header>
    <h1>تعاریف</h1>
    <h4 on:click={showAll}>
      نسخه فعال: 1.1 - {total != -1 ? total + ' تعریف' : ''}
    </h4>
    <p id="add" style="display:none">+</p>
  </header>

  <section id="searchBar">
    <img src="img/search.svg" alt="search" />
    <input
      type="text"
      on:keydown={searchRun}
      id="search"
      placeholder="جستجو در لغات (مانند انابت)" />
  </section>

  <section id="terms">
    <ol id="alefba">
      {#each alefba as harf, index}
        <li
          class="{index === selectIndex ? 'active' : ''}
          {alefbaExist.indexOf(harf) == -1 ? 'not' : ''}"
          on:click={e => alphabetClick(e, index)}>
          {harf}
        </li>
      {/each}
    </ol>
    <ol id="taarif">
      {#await promise}
        <div class="loading">
          <img src="img/load.gif" alt="loading" />
          <p>در حال بارگذاری ...</p>
        </div>
      {:then}
        <li class="header">{header || alefba[selectIndex]}</li>
        {#if output.length < 1}
          <li>
            <div class="des">
              <p class="new">موردی ثبت نشده است</p>
            </div>
          </li>
        {:else}
          {#each output as term}
            <li>
              <p class="title">{term.title}</p>
              <div class="des">
                {#each term.tarif as tarif}
                  <p class="new">
                    {tarif.des}
                    <sup class="ref">{tarif.ref + ' - ' + tarif.note}</sup>
                  </p>
                {/each}
              </div>
            </li>
          {/each}
        {/if}
      {:catch error}
        <p style="color: red">{error.message}</p>
      {/await}
    </ol>
  </section>
</main>
